'use client';
import { useEffect } from 'react';

import { useAccountContext } from '~context/account';
import { usePaywallContext } from '~context/paywall';
import type { PaymentReasonType } from '~features/annals/enums/payment';
import { PaymentReason } from '~features/annals/enums/payment';

import { useNeedsToShowNeuronsPaywall } from './useNeedsToShowNeuronsPaywall';
import { useNeedsToShowPaywall } from './useNeedsToShowPaywall';

export const useShowPaywall = (reasonType: PaymentReasonType) => {
	const { openPaywall } = usePaywallContext();
	const { hasSubscription } = useAccountContext();

	const { paywallIntent, setNeedsToShowPaywall } = useNeedsToShowPaywall();
	const { neuronsPaywallIntent, setNeedsToShowNeuronsPaywall } =
		useNeedsToShowNeuronsPaywall();

	useEffect(() => {
		if (paywallIntent && !hasSubscription) {
			openPaywall({
				reason: PaymentReason.Deeplink,
				reasonType,
				prefer: 'subscription',
			})();
			setNeedsToShowPaywall(undefined);
		}

		if (neuronsPaywallIntent) {
			openPaywall({
				reason: PaymentReason.Deeplink,
				reasonType,
				prefer: 'neurons',
			})();
			setNeedsToShowNeuronsPaywall(undefined);
		}
	}, [
		setNeedsToShowNeuronsPaywall,
		setNeedsToShowPaywall,
		hasSubscription,
		openPaywall,
		paywallIntent,
		neuronsPaywallIntent,
		reasonType,
	]);
};

export const Paywall = ({ reasonType }: { reasonType: PaymentReasonType }) => {
	useShowPaywall(reasonType);
	return null;
};
